var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weui-toast {\n  /*max-width: 90% !important;*/\n  width: auto !important;\n  padding: 0 0.3rem;\n}\n#app {\n  height: 100vh;\n  position: relative;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  background: url(" + escape(require("@/assets/image/插图底纹@2x.png")) + ") no-repeat;\n  background-size: 5.4rem;\n  background-position: center bottom;\n  overflow: hidden;\n}\n@media screen and (max-width: 320px) {\n#app {\n    background-size: 4.8rem;\n}\n}\n", ""]);

// exports
